import 'css-chunksrc/client/pages/listPage/details/nameForm/styles.scss';export default {
  "input": "_input_1prjf_1",
  "invalid": "_invalid_1prjf_16"
};